function checkProperRole(userRole, requiredRole) {
    return requiredRole.some(function (role) {
        return userRole.indexOf(role) > -1;
    });
}

export default checkProperRole;


// WEBPACK FOOTER //
// ./src/utils/checkProperRole.js